import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NbDialogRef} from '@nebular/theme';
import {CommonService} from '../../../../../shared/services/common.service';
import {FormService} from '../../../../../shared/services/form.service';
import {TaskStatus} from '../../../../../shared/models/response/task-status';
import {TaskStatusService} from '../../../../../shared/services/task-status.service';
import { ComponentPermission } from '../../../../../component.permission';

@Component({
  selector: 'ngx-task-status-update',
  templateUrl: './task-status-update.component.html',
  styleUrls: ['./task-status-update.component.scss'],
})
export class TaskStatusUpdateComponent implements OnInit {

  ComponentPermission = ComponentPermission;
  form: FormGroup;
  isSubmitted = false;

  @Input()
  data: TaskStatus;

  constructor(protected ref: NbDialogRef<TaskStatusUpdateComponent>,
              private taskStatusService: TaskStatusService,
              private commonService: CommonService,
              private formService: FormService) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      taskStatusId: new FormControl(this.data.taskStatusId, [
        Validators.required,
      ]),
      name: new FormControl(this.data.name, [
        Validators.required,
      ]),
      description: new FormControl(this.data.description),
    });
  }

  submit() {
    const form = this.form.value;
    this.formService.extractErrorMessage(this.form);
    if (this.form.invalid) {
      this.isSubmitted = true;
      return;
    }
    this.taskStatusService.update(form).subscribe(
      result => {
        this.commonService.info('Update success.');
        this.ref.close(result);
      },
      error => {
        this.commonService.warningHtml(error.message);
      },
    );
  }

  cancel() {
    this.ref.close();
  }

  showError(name: string): string {
    return this.form.controls[name]
    && this.form.controls[name].errors
    && (this.form.controls[name].dirty
      || this.form.controls[name].touched
      || this.isSubmitted) ? 'has-error' : '';
  }

  colorChange(colorValue: string) {
    this.form.controls.color.setValue(colorValue);
  }

}
